// @flow
import React from 'react';

import styles from './Loading.module.scss';

const Loading = () => <div className={styles.loading} />;

export default Loading;
